import angular from 'angular';

import _ from './user-table.styles.scss';

import UserTableController from './user-table.controller';

export default angular.module('autoboard.userTable', [])
  .controller('UserTableController', UserTableController)
  .name;